import { useState, useEffect, useContext } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeContext } from "./context/ThemeContext";
import ModernSidebar from "./components/ModernSidebar";
import ModernHeader from "./components/ModernHeader";

import "./App.css";

const App = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDark } = useContext(ThemeContext);

  const [collapsed, setCollapsed] = useState(false);

  const handleToggleSidebar = () => {
    console.log("Toggle sidebar called, current collapsed state:", collapsed);
    const newCollapsedState = !collapsed;
    console.log("Setting collapsed to:", newCollapsedState);
    setCollapsed(newCollapsedState);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    // Set theme on document for CSS variables
    document.documentElement.setAttribute(
      "data-theme",
      isDark ? "dark" : "light"
    );
    // Add or remove .dark class on body for global dark mode styling
    if (isDark) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [isDark]);

  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;
    const routeTitles = {
      "/d/dash": "Dashboard",
      "/d/nsdl": "NSDL Data",
      "/admin": "Admin Panel",
      "/d/plans": "Subscription Plans",
      "/d/orders": "Orders",
      "/d/payments": "Payments",
      "/d/issuer-financial-reports": "Financial Results",
      "/d/issuer-list": "Issuers",
    };
    return routeTitles[path] || "SimplyBond";
  };

  const getPageSubtitle = () => {
    const path = location.pathname;
    const routeSubtitles = {
      "/d/dash": "",
      "/d/nsdl": "Comprehensive bond data",
      "/admin": "Administrative controls",
      "/d/plans": "Choose your subscription",
      "/d/orders": "Track your orders",
      "/d/payments": "Payment history and details",
      "/d/issuer-financial-reports": "Financial performance metrics",
      "/d/issuer-list": "Comprehensive bond issuer directory",
    };
    return routeSubtitles[path] || "Your bond investment platform";
  };

  return (
    <div className="modern-layout">
      <ModernSidebar collapsed={collapsed} onToggle={handleToggleSidebar} />

      <div className={`main-content${collapsed ? " sidebar-collapsed" : ""}`}>
        <ModernHeader
          collapsed={collapsed}
          onToggleSidebar={handleToggleSidebar}
          onGoBack={location.pathname !== "/d/dash" ? handleGoBack : null}
          title={getPageTitle()}
          subtitle={getPageSubtitle()}
        />

        <main className="modern-content">
          <div className="content-wrapper">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Toast Container for notifications */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={isDark ? "dark" : "light"}
      />
    </div>
  );
};

export default App;
